import { render, staticRenderFns } from "./ViewServiceCenterPage.vue?vue&type=template&id=e2fd6e2c"
import script from "./ViewServiceCenterPage.vue?vue&type=script&lang=js"
export * from "./ViewServiceCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports